var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContactActive = function SvgContactActive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6341 7.22712C18.8195 7.22712 19.7805 6.26773 19.7805 5.08426C19.7805 3.9008 18.8195 2.94141 17.6341 2.94141C16.4487 2.94141 15.4878 3.9008 15.4878 5.08426C15.4878 6.26773 16.4487 7.22712 17.6341 7.22712Z",
    stroke: "#0258FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6341 10.4414C15.3368 10.4414 12.7583 11.8355 12.5366 12.3164C12.3549 12.7105 12.2683 13.9235 12.2683 13.9235C12.2683 14.3664 12.628 14.7271 13.0716 14.7271H22.1967C22.6403 14.7271 23 14.3664 23 13.9235C23 13.9235 22.9134 12.7105 22.7317 12.3164C22.51 11.8355 19.9315 10.4414 17.6341 10.4414V10.4414Z",
    stroke: "#0258FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51223 7.10322C10.108 7.10322 11.4015 5.81173 11.4015 4.2186C11.4015 2.62547 10.108 1.33398 8.51223 1.33398C6.91651 1.33398 5.62292 2.62547 5.62292 4.2186C5.62292 5.81173 6.91651 7.10322 8.51223 7.10322Z",
    stroke: "#082344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5122 10.5645C5.2959 10.5645 1.68602 12.4412 1.37561 13.0885C1.12123 13.619 1 15.252 1 15.252C1 15.8482 1.50352 16.3337 2.12465 16.3337H14.8997C15.5209 16.3337 16.0244 15.8482 16.0244 15.252C16.0244 15.252 15.9032 13.619 15.6488 13.0885C15.3384 12.4412 11.7285 10.5645 8.5122 10.5645Z",
    fill: "white",
    stroke: "#082344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact-active.72f3ec64.svg";
export { ForwardRef as ReactComponent };